import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@univdiam/ui/components/button";
import { ShapeSizeDataTable } from "@univdiam/ui/customComponents/ShapeSizeList/data-table";
import { groupColumns } from "@univdiam/ui/customComponents/ShapeSizeList/columns";
import { EditShapeSizeForm } from "@univdiam/ui/customComponents/ShapeSizeList/EditShapeSizeForm";

import api from "@/http/api";

export default function ShapeSizePage() {
  const [data, setData] = useState([]);
  const [editShapeSizeData, setEditShapeSizeData] = useState(null);

  useEffect(() => {
    api
      .get("/api/shape_size")
      .then((res) => {
        const transformed = res.data.data.map((shape_size: any) => ({
          shape_size_id: shape_size.shape_size_id.toString(),
          name: shape_size.shape,
          size: shape_size.size,
          status: shape_size.status === 1 ? "Enabled" : "Disabled",
        }));
        setData(transformed);
      })
      .catch((err) => console.error("Failed to fetch shape size", err));
  }, []);

  const handleDelete = async (id: string) => {
    console.log(id);
    const confirm = window.confirm(
      "Are you sure you want to delete this shape size?"
    );
    if (!confirm) return;

    try {
      const res = await api.delete(`/api/shape_size/${id}`);
      if (res.status === 200) {
        alert("ShapeSize deleted successfully.");
        // setData(prev => prev.filter(group => group.group_id !== id))
      } else {
        alert("Failed to delete shape size.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Something went wrong.");
    }
  };

  const handleEdit = async (id: string) => {
    try {
      const res = await api.get(`/api/shape_size/${id}`);
      if (res.status === 200) {
        setEditShapeSizeData(res.data);
        // setData(prev => prev.filter(group => group.group_id !== id))
      } else {
        alert("Failed to fetch group.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Something went wrong.");
    }
  };

  const navigate = useNavigate();

  const handleAddShapeSize = () => {
    navigate("/shape-size/add");
  };

  const columns = groupColumns({ onEdit: handleEdit, onDelete: handleDelete });

  return (
    <div className="p-5">
      <div className="flex justify-between mb-4">
        <h1 className="text-xl font-semibold">Shape Size Management</h1>
        {/* <Button onClick={() => setCreateShapeSize(true)}>+ Add Shape size</Button> */}
        <div className="flex justify-end mb-4">
          <Button onClick={handleAddShapeSize}>+ Add Shape Size</Button>
        </div>
      </div>
      <ShapeSizeDataTable columns={columns} data={data} />
      {editShapeSizeData && (
        <EditShapeSizeForm
          group={editShapeSizeData}
          onCancel={() => setEditShapeSizeData(null)}
          onSave={() => {
            setEditShapeSizeData(null);
            fetchShapeSize(); // refresh table
          }}
        />
      )}
    </div>
  );
}
